import React, { Component } from 'react';
import { api } from '../../../services';
import { Card, Col, Icon, Table, Input } from 'antd';
import { withRouter } from "react-router-dom";
import { inject, observer } from 'mobx-react';
import RangeFilter from '../../../common/components/RangeFilter';
import ToCarView from '../../../common/icons/CarIcon';

import moment from 'moment';

import './Tickets.css';
import {reaction} from "mobx";

const queryStringFromFilters = filters => {
  let _filters = [];
  if (filters) {
    if (filters.id && filters.id.length > 0) {
      _filters.push(`ticketId=${filters['id']}`);
    }
    if (filters['car.plate'] && filters['car.plate'].length > 0) {
      _filters.push(`plate=${filters['car.plate']}`);
    }
    if (filters['car.make'] && filters['car.make'].length > 0) {
      _filters.push(`make=${filters['car.make']}`);
    }
    if (filters['car.model'] && filters['car.model'].length > 0) {
      _filters.push(`model=${filters['car.model']}`);
    }
    if (filters['car.type'] && filters['car.type'].length > 0) {
      _filters.push(`carType=${filters['car.type']}`);
    }
    if (filters['car.registrationYear'] && filters['car.registrationYear'].length > 0) {
      _filters.push(`registrationYear=${filters['car.registrationYear']}`);
    }
    if (filters['dealer.name'] && filters['dealer.name'].length > 0) {
      _filters.push(`ticketDealerId=${filters['dealer.name']}`);
    }
    if (filters.channel && filters.channel.length > 0) {
      _filters.push(`channel=${filters['channel']}`);
    }
    if (filters.type && filters.type.length > 0) {
      _filters.push(`type=${filters['type']}`);
    }
    if (filters.assignee && filters.assignee.length > 0) {
      _filters.push(`assignee=${filters['assignee']}`);
    }
    if (filters.createdAt && filters.createdAt.length > 1) {
      _filters.push(`createdAt=${parseRange(filters['createdAt'])}`);
    }
    if (filters.status && filters.status.length > 0) {
      _filters.push(`status=${filters['status']}`);
    }
  }
  return _filters.join('&');
};

const parseRange = range => {
  return [
    range[0]
      .startOf('day')
      .utc()
      .format(),
    range[1]
      .startOf('day')
      .utc()
      .format()
  ];
};

@withRouter
@inject('translationsStore', 'commonStore', 'authStore')
@observer
class Tickets extends Component {
  constructor(props) {
    super(props);
    const { translationsStore, commonStore, authStore } = props;
    this.commonStore = commonStore;
    this.state = {
      ticketsLoading: "false",
      tickets: [],
      selectedRowKeys: new Set(),
      unselectedRowKeys: new Set(),
      filters: {},
      defaultFilters: {
        carMakes: [],
        carModels: [],
        carTypes: [],
        carRegistrationYears: [],
        dealers: [],
        assignees: [],
        userNames: []
      },
      sorters: { field: 'createdAt', order: 'DESC' }
    };
    reaction(
      () => this.commonStore.selectedDealers,
      fn => {
        this.loadData(1, 20);
        this.loadFilters();
      }
    );
  }

  loadData(page, size, sort, order, filters) {
    this.setState({ ticketsLoading: true });
    const selectedDealers = (this.commonStore && this.commonStore.selectedDealers)? this.commonStore.selectedDealers : [];
    return api('getTickets', { page, size, sort, order, filters, selectedDealers }).then(tickets => {
      this.setState(
        {
          tickets: tickets,
          ticketsLoading: false
        }
      );
    });
  }

  loadFilters() {
    return api('getTicketCarFilters').then(filters => {
      this.setState(
        {
          defaultFilters: filters
        }
      );
    });
  }

  handleTableChange(pagination, filters, sorter) {
    console.log(sorter);
    this.setState(
      () => {
        return { filters: queryStringFromFilters(filters) };
      },
      () => {
        console.log(sorter.order);
        let order = sorter.order === 'descend' ? 'DESC' : 'ASC';
        this.loadData(pagination.current, pagination.pageSize, sorter.field, order, this.state.filters);
      }
    );
  }

  componentDidMount() {
    this.loadData(1, 20);
    this.loadFilters();
  }
    
  render() {
    const { translationsStore, commonStore, authStore } = this.props;
    let { filters, defaultFilters } = this.state;
    filters = filters || {};
    let localDefaultFilters = {
      channels: [
        {
          text: translationsStore.translate('tickets.channels.DEALER'),
          value: 'DEALER'
        },
        {
          text: translationsStore.translate('tickets.channels.AIR'),
          value: 'AIR'
        }
      ],
      types: [
        {
          text: translationsStore.translate('tickets.types.DEFECTIVE_DEVICE'),
          value: 'DEFECTIVE_DEVICE'
        },
        {
          text: translationsStore.translate('tickets.types.INCOMPATIBLE_DEVICE'),
          value: 'INCOMPATIBLE_DEVICE'
        },
        {
          text: translationsStore.translate('tickets.types.INCORRECT_DATA'),
          value: 'INCORRECT_DATA'
        },
        {
          text: translationsStore.translate('tickets.types.DIAGNOSTICS'),
          value: 'DIAGNOSTICS'
        },
        {
          text: translationsStore.translate('tickets.types.ANTITHEFT'),
          value: 'ANTITHEFT'
        },
        {
          text: translationsStore.translate('tickets.types.APP_CREDENTIALS'),
          value: 'APP_CREDENTIALS'
        },
        {
          text: translationsStore.translate('tickets.types.PORTABILITY'),
          value: 'PORTABILITY'
        },
        {
          text: translationsStore.translate('tickets.types.OTHER'),
          value: 'OTHER'
        }
      ],
      statuses: [
        {
          text: translationsStore.translate('tickets.statuses.OPEN'),
          value: 'OPEN'
        },
        {
          text: translationsStore.translate('tickets.statuses.INPROGRESS'),
          value: 'INPROGRESS'
        },
        {
          text: translationsStore.translate('tickets.statuses.CLOSED'),
          value: 'CLOSED'
        }
      ]

    }
    let isAdmin = authStore.isAdmin;
    const columns = [ 
      {
        dataIndex: 'id',
        key: 'id',
        title: translationsStore.translate('tickets.column.ticketId'),
        sorter: true,
        render: text => <span>{Number(text).toLocaleString()}</span>,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div id="TicketId" style={{ padding: '10px' }}>
            <Input
              ref={ele => (this.searchInput = ele)}
              value={selectedKeys[0] || ''}
              onChange={e => {
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }}
              onPressEnter={e => {
                setSelectedKeys(e.target.value ? [e.target.value] : [])
                setTimeout(() => {
                  confirm();
                }, 0);
              }}
              style={{ width: 120 }}
            />
          </div>
        ),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            });
          }
        }
      }, 
      {
        dataIndex: 'car.plate',
        key: 'car.plate',
        title: translationsStore.translate('tickets.column.plate'),
        sorter: true,
        render: text => <span>{text}</span>,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div id="Plate" style={{ padding: '10px' }}>
            <Input
              ref={ele => (this.searchInput = ele)}
              value={selectedKeys[0] || ''}
              onChange={e => {
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }}
              onPressEnter={e => {
                setSelectedKeys(e.target.value ? [e.target.value] : [])
                setTimeout(() => {
                  confirm();
                }, 0);
              }}
              style={{ width: 120 }}
            />
          </div>
        ),
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => {
              this.searchInput.focus();
            });
          }
        }
      },
      {
        dataIndex: 'car.make',
        key: 'car.make',
        title: translationsStore.translate('tickets.column.make'),
        render: make => make.descrizione,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filters: [...defaultFilters.carMakes],
        filterMultiple: true
      },
      {
        dataIndex: 'car.model',
        key: 'car.model',
        title: translationsStore.translate('tickets.column.model'),
        render: model => model.descrizione,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filters: [...defaultFilters.carModels],
        filterMultiple: true
      },
      /*
      ... (isAdmin) ? [{
        dataIndex: 'car.type',
        key: 'car.type',
        title: translationsStore.translate('tickets.column.carType'),
        render: type => type.descrizione,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filters: [...defaultFilters.carTypes],
        filterMultiple: true
      }] : [],
      */
      {
        dataIndex: 'car.registrationYear',
        key: 'car.registrationYear',
        title: translationsStore.translate('tickets.column.registrationYear'),
        sorter: true,
        render: text => <span>{text}</span>,
        align: 'center',
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filters: [...defaultFilters.carRegistrationYears],
        filterMultiple: true
      },
      ... (isAdmin) ? [{
        dataIndex: 'dealer.name',
        key: 'dealer.name',
        title: translationsStore.translate('tickets.column.dealerName'),
        render: text => <span>{text}</span>,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filters: [...defaultFilters.dealers],
        filterMultiple: true
      }] : [],
      {
        dataIndex: 'userName',
        key: 'userName',
        title: translationsStore.translate('tickets.column.author'),
        sorter: true,
        render: text => <span>{text}</span>,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filters: [...defaultFilters.userNames],
        filterMultiple: true
      },
      {
        dataIndex: 'channel',
        key: 'channel',
        title: translationsStore.translate('tickets.column.channel'),
        sorter: true,
        render: text => <span>{translationsStore.translate('tickets.channels.' + text)}</span>,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filters: [...localDefaultFilters.channels],
        filterMultiple: true
      },
      {
        dataIndex: 'type',
        key: "type",
        align: 'left',
        title: translationsStore.translate('tickets.column.type'),
        sorter: true,
        render: text => <span>{translationsStore.translate('tickets.types.' + text)}</span>,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filters: [...localDefaultFilters.types],
        filterMultiple: true
      },
      ... (isAdmin) ? [{
        dataIndex: 'assignee',
        key: "assignee",
        title: translationsStore.translate('tickets.column.assignee'),
        sorter: true,
        render: text => <span>{text}</span>,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filters: [...defaultFilters.assignees],
        filterMultiple: true
      }] : [],
      {
        dataIndex: 'createdAt',
        key: "createdAt",
        align: 'center',
        title: translationsStore.translate('tickets.column.createdAt'),
        sorter: true,
        render: (text, record) => <span>{record.createdAt ? moment(record.createdAt).format(commonStore.longDateFormat.L) : '-'}</span>,
        defaultSortOrder: 'descend',
        filterDropdown: props => <RangeFilter ref={ele => (this.rangeFilter = ele)} {...props} />,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />
      },
      /*
      {
        dataIndex: 'assignedAt',
        align: 'center',
        title: translationsStore.translate('tickets.column.assignedAt'),
        sorter: true,
        render: (text, record) => <span>{record.assignedAt ? moment(record.assignedAt).format(commonStore.longDateFormat.L) : '-'}</span>
      },
      {
        dataIndex: 'closedAt',
        align: 'center',
        title: translationsStore.translate('tickets.column.closedAt'),
        sorter: true,
        render: (text, record) => <span>{record.closedAt ? moment(record.closedAt).format(commonStore.longDateFormat.L) : '-'}</span>
      },
      */
	    {
        dataIndex: 'status',
        key: "status",
        align: 'center',
        title: translationsStore.translate('tickets.column.status'),
        sorter: true,
        render: text => <span>{translationsStore.translate('tickets.statuses.' + text)}</span>,
        filterIcon: filtered => <Icon type="filter" style={{ color: filtered ? '#108ee9' : '#fff' }} />,
        filters: [...localDefaultFilters.statuses],
        filterMultiple: true
      },
      {
        dataIndex: '',
        width: '50px',
        title: '',
        className: 'goToCarview',
        render: (text, record) => <ToCarView style={{ cursor: 'pointer', fontSize: '2rem' }} onClick={() => this.props.history.push(`/carview/${record.carId}?from=ticketlist&ticketId=${record.id}`)} />
      }
    ];
    
    return (
      <div className="Tickets">
        <Card className="TicketsTable" bodyStyle={{ padding: '24px 10px', position: 'relative' }}>
          <Col>
            <Table
              id="TicketsTable"
              rowKey="id"
              dataSource={this.state.tickets.rows || []}
              columns={columns}
              onChange={(...params) => this.handleTableChange(...params)}
              pagination={{ pageSize: 20, position: 'both', total: this.state.tickets.count }}
              />
          </Col>
        </Card>
      </div>
    );
  }
}

export default Tickets;
